import React, { useState } from 'react';
import { Col as RBCol } from 'react-bootstrap';
import IconProvider from '../../../../SharedUI/components/IconProvider';
import { ActionsController } from '../../ActionsController';
import { CRAFT_ELEMENTS } from '../../../config/craftElements';
import { useFunnelColorTheme, usePresets } from '../../../../redux/slices/mainData';
import { getElementColor } from '../../../helper';
import { FUNNEL_THEME_KEYS, funnelPresetElements } from '../../../../redux/interfaces/mainData';
import { IconType } from '../../SingleChoiceComponent/interfaces';

const FAQTileDefaultProps = {
  type: IconType.icon,
  value: 'IoIosArrowUp',
  borderRadius: '',
  isFirstRender: true,
  backgroundColor: FUNNEL_THEME_KEYS.CARD_BACKGROUND_COLOR,
  cardIconColor: FUNNEL_THEME_KEYS.CARD_ICON_COLOR,
  isPresetOn: true,
  accordionCollapse: true,
};

interface Props {
  type?: string;
  value?: string;

  borderRadius?: string;
  backgroundColor?: string;
  cardIconColor?: string;
  isPresetOn?: boolean;
  children: any;
}

export default function FAQTile(FAQTileProps: Props): React.ReactElement {
  const { isPresetOn = true, ...props } = {
    ...FAQTileDefaultProps,
    ...FAQTileProps,
  };
  const [accordionCollapse, setAccordionCollapse] = useState(false);
  const theme = useFunnelColorTheme();

  const presets = usePresets(funnelPresetElements.FAQ);

  const presetsOrProps = isPresetOn ? { ...props, ...presets } : props;

  const iconColor = isPresetOn
    ? // @ts-expect-error
      presets.cardIconColor
    : props.cardIconColor;

  const iconName = isPresetOn
    ? // @ts-expect-error
      presets.icon
    : props.value;

  const customBackgroundColor = isPresetOn
    ? getElementColor(
        // @ts-expect-error
        presets.backgroundColor,
        theme,
      )
    : getElementColor(props.backgroundColor, theme);

  const customBorderRadius = isPresetOn ? presetsOrProps.borderRadius : presetsOrProps.borderRadius;

  return (
    <ActionsController
      {...props}
      parentTag={RBCol}
      parentTagProps={{
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
      }}
      className={`choice-wrapper px-0`}
    >
      <div
        style={{
          borderRadius: customBorderRadius,
          background: customBackgroundColor,
        }}
      >
        <div className="faq-container" onClick={() => setAccordionCollapse(!accordionCollapse)}>
          <div className={`${props.type === 'emoji' ? 'faq-icon' : ''}`}>
            <IconProvider
              className="icon-element faq-icon"
              name={iconName}
              color={iconColor}
              style={{
                color: getElementColor(iconColor, theme),
                ...(!accordionCollapse &&
                  iconName.toLowerCase().includes('arrow') && { transform: 'rotate(180deg)' }),
              }}
            />
          </div>
          <div className="d-flex flex-column justify-content-center faq-content">
            {props.children[0] || 'Default Header'}
            {accordionCollapse && <div>{props.children[1] || 'Default Body Content'}</div>}
          </div>
        </div>
      </div>
    </ActionsController>
  );
}

FAQTile.craft = {
  name: CRAFT_ELEMENTS.FAQ_TILE,
  props: FAQTileDefaultProps,
};
